module.exports = __webpack_public_path__ + "img/LF002-03.4444fe87.jpg";